/**
 * v1.0.0 Breaking Changes:
 * - replaced setDefinitions prop with setDefinition prop.
 *    - setDefinition(idx, definition)
 */

import GroupingComplicationSelector from './GroupingComplicationSelector';

export default GroupingComplicationSelector;
